var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamlik(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    "data-name": "katman 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31,0c-4.7,3.6-5.7,8.5-6.7,13.8-1.1,6.1-3.3,12-4.9,18-.5,1.7-1.6,2.6-3.2,2.8-3.2.5-6.4.4-9.5,0-2-.2-3.3-1.6-2.2-3.5,3.8-6.6,4.8-14.2,7.9-21C14.9,4.6,18.6,1.1,25,.7,27,.6,29,.2,31,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamlik);
export default __webpack_public_path__ + "static/media/camlik.6c1963f90484000489a0690d2ccf128c.svg";
export { ForwardRef as ReactComponent };